import environment from "@environment";

export const Utils = {

  GetCulture: () => {
    const paths = window.location.pathname.split("/");
    const isBusiness = Utils.IsBusiness();
    const locale = (paths.length > 0) ? (isBusiness) ? paths[2] : paths[1] : environment.defaultLocale;
    const params = new URLSearchParams(window.location.search);
    const localCulture = locale === "en-dth" ? params.get("dth") : locale;
    const lang = locale.split("-")[0];

    const site = isBusiness ? "business" : null;

    const settings = {
      lang: lang,
      culture: localCulture,
      site: site
    };

    return settings;
  },

  IsBusiness() {
    const pathName = window.location.pathname;
    return pathName.includes("/business");
  }
}